<template>
  <AppPage class="HelpPage">
    <AppHeader title="AYUDA"
      :left-action="goBack"
      :right-action="goPedido"
     />
    <i class="fa fa-question-circle help-icon"></i>
    <AppSection>
      <p class="text-muted">PARA CUALQUIER DUDA O CONSULTA SOBRE EL PROCESO DE PEDIDO O NUESTROS SERVICIOS, PUEDES PONERTE EN CONTACTO CON NOSTROS EN EL TELÉFONO</p>
      <div class="alert alert-info">
        C/ SOT DE LES VERNEDES 2. <br>
        08396 SANT CEBRIÀ DE VALLALTA
      </div>
      <a href="tel:0034937632635" class="btn btn-lg btn-block btn-action">93 763 26 35</a>
      <p class="text-muted">O EN LA SIGUIENTE DIRECCIÓN DE EMAIL</p>
      <a href="mailto:serf@frutosrojos.com" class="btn btn-lg btn-block btn-action">serf@frutosrojos.com</a>
      <p class="text-muted">
        <strong>HORARI BOTIGA</strong>
        <ul class="horario">
          <li>Dilluns - Divendres  9h. a 14h. / 17h. a 19,30h.</li>
          <li>Dissabtes de 9h. a 14h.</li>
          <li>Diumenges i Festius : Tancat.</li>
        </ul>
      </p>
      <button class="btn btn-lg btn-block btn-action" @click="onShowConditionsPopup"> Política de ventas y devoluciones</button>
    </AppSection>
  </AppPage>
</template>
<script>
export default {
  methods: {
    onShowConditionsPopup() {
      this.$store.commit('showConditions', true)
    },
    goBack() {
      this.$router.go(-1)
    },
    goPedido() {
      this.$router.push('/order')
    }
  }
}
</script>

<style lang="scss">
.HelpPage {
  text-align: center;

  .help-icon {
    color: #0a8dce;
    font-size: 5.2rem;
    margin-top: 1rem;
  }

  p {
    font-size: 0.89rem;
    margin: 1.4rem 0;
  }

  .btn-action {
    background-color: #ccc;
    color: #343434;
    padding: 1rem;
  }

  .horario {
    padding: 0.42rem 0 0 0;
    margin: 0;
    list-style: none;

    li {
      padding-top: 0.89rem 0;
    }
  }
}
</style>

